import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@/../environments/environment';
import { Titulo, EditalTitulo, CreateTituloRequest, CreateEditalTituloRequest, EditalTituloResponse } from '../models/titulo.model';
import { PageResponse, StatusCount } from './pagination.types';

@Injectable({
  providedIn: 'root'
})
export class TituloService {
  private apiUrl = `${environment.apiUrl}/admin/titulos`;

  constructor(private http: HttpClient) {}

  // Títulos
  getAll(): Observable<Titulo[]> {
    return this.http.get<Titulo[]>(this.apiUrl);
  }

  getAtivos(): Observable<Titulo[]> {
    return this.http.get<Titulo[]>(`${this.apiUrl}/ativos`);
  }

  getById(id: number): Observable<Titulo> {
    return this.http.get<Titulo>(`${this.apiUrl}/${id}`);
  }

  create(titulo: CreateTituloRequest): Observable<Titulo> {
    return this.http.post<Titulo>(this.apiUrl, titulo);
  }

  update(id: number, titulo: CreateTituloRequest): Observable<Titulo> {
    return this.http.put<Titulo>(`${this.apiUrl}/${id}`, titulo);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  // Títulos do Edital
  getEditalTitulos(editalId: number): Observable<EditalTitulo[]> {
    return this.http.get<EditalTitulo[]>(`${environment.apiUrl}/admin/editais/${editalId}/titulos`);
  }

  getEditalTitulosAtivos(editalId: number): Observable<EditalTitulo[]> {
    return this.http.get<EditalTitulo[]>(`${environment.apiUrl}/admin/editais/${editalId}/titulos/ativos`);
  }

  // Endpoint público para candidatos (se disponível)
  getEditalTitulosAtivosPublic(editalId: number): Observable<EditalTituloResponse> {
    return this.http.get<EditalTituloResponse>(`${environment.apiUrl}/candidatos/inscricoes/editais/${editalId}/titulos/ativos`);
  }

  getEditalTituloById(editalId: number, id: number): Observable<EditalTitulo> {
    return this.http.get<EditalTitulo>(`${environment.apiUrl}/admin/editais/${editalId}/titulos/${id}`);
  }

  createEditalTitulo(editalId: number, editalTitulo: CreateEditalTituloRequest): Observable<EditalTitulo> {
    return this.http.post<EditalTitulo>(`${environment.apiUrl}/admin/editais/${editalId}/titulos`, editalTitulo);
  }

  updateEditalTitulo(editalId: number, id: number, editalTitulo: CreateEditalTituloRequest): Observable<EditalTitulo> {
    return this.http.put<EditalTitulo>(`${environment.apiUrl}/admin/editais/${editalId}/titulos/${id}`, editalTitulo);
  }

  deleteEditalTitulo(editalId: number, id: number): Observable<void> {
    return this.http.delete<void>(`${environment.apiUrl}/admin/editais/${editalId}/titulos/${id}`);
  }

  /**
   * Lista títulos paginados
   * GET /api/admin/titulos/paginado
   */
  listarPaginado(
    page: number = 0,
    size: number = 10,
    sortBy: string = 'nome',
    sortDirection: 'ASC' | 'DESC' = 'ASC',
    apenasAtivos?: boolean
  ): Observable<PageResponse<Titulo>> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sortBy', sortBy)
      .set('sortDirection', sortDirection);
    
    if (apenasAtivos !== undefined) {
      params = params.set('apenasAtivos', apenasAtivos.toString());
    }
    
    return this.http.get<PageResponse<Titulo>>(`${this.apiUrl}/paginado`, { params });
  }

  /**
   * Obtém contagem de status dos títulos
   * GET /api/admin/titulos/status
   */
  getStatus(): Observable<StatusCount> {
    return this.http.get<StatusCount>(`${this.apiUrl}/status`);
  }
}
